import { Spacer } from '@ampcore/adel-react'
import { SpacerSpacing } from '@ampcore/adel-react'
import React from 'react'
import xss from 'xss'

export type ArticleHeroSatelliteProps = {
  header: string
  description: string
  componentSpacing?: SpacerSpacing
  testId?: string
}

export const ArticleHeroSatellite = (props: ArticleHeroSatelliteProps) => {
  const { header, description, componentSpacing, testId } = props

  return (
    <Spacer spacing={componentSpacing}>
      <section className="ArticleHeroSatellite u-sizeConstrained">
        <div className="ArticleHeroSatellite-header u-posRelative">
          <div className="ArticleHeroSatellite-header-content">
            <h1
              className="u-lg-size8of12 u-textColorNeutral"
              data-testid={testId ? `${testId}-heading` : null}
              dangerouslySetInnerHTML={{ __html: xss(header) }}
            />
            <div
              className="u-lg-size8of12 u-paddingTop8 u-paddingBottom20"
              dangerouslySetInnerHTML={{ __html: xss(description) }}
              data-testid={testId ? `${testId}-content` : null}
            ></div>
          </div>
        </div>
      </section>
    </Spacer>
  )
}
